var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseCross = function SvgCloseCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9088 1.09151L6.94487 6.0554L11.9512 11.0617L11.039 11.9739L6.0327 6.96757L1.09002 11.9102L0.283923 11.1041L5.2266 6.16147L0.220282 1.15515L1.13245 0.242986L6.13877 5.2493L11.1027 0.285413L11.9088 1.09151Z",
    fill: "#0A0909"
  })));
};
export default SvgCloseCross;